import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { tokens } from '../design/tokens';
import { Video } from '../types'; // Importando del tipo centralizado

interface VideoCardProps {
  video: Video;
  onViewVideo: (video: Video) => void;
}

const Card = styled.div<{ $bgImage?: string }>`
  background: ${props => props.$bgImage ? `linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.6)), url(${props.$bgImage})` : 'white'};
  background-size: cover;
  background-position: center;
  border-radius: 15px;
  padding: 25px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.15);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  height: 350px;
  color: white;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);
  }
`;

const Title = styled.h3`
  font-size: 22px;
  font-weight: bold;
  color: white;
  margin: 0 0 10px 0;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.8);
`;

const Description = styled.p`
  font-size: 15px;
  color: white;
  margin: 0 0 15px 0;
  line-height: 1.5;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.8);
`;

const Duration = styled.div`
  font-size: 13px;
  color: white;
  display: flex;
  align-items: center;
  gap: 5px;
  margin-bottom: 15px;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.8);
`;

const Content = styled.div`
  flex: 1;
  overflow: hidden;
`;

const ViewButton = styled.button`
  background: linear-gradient(135deg, ${tokens.colors.primary} 0%, ${tokens.colors.secondary} 100%);
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 25px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  width: 100%;
  margin-top: auto;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: scale(1.05);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.4);
  }
`;

const VideoCard = forwardRef<HTMLDivElement, VideoCardProps>(({ video, onViewVideo }, ref) => {
  return (
    <Card ref={ref} $bgImage={video.icon}>
      <Content>
        <Title>{video.title}</Title>
        <Description>{video.description.length > 100 ? video.description.substring(0, 100) + '...' : video.description}</Description>
        <Duration>⏱️ {video.duration}</Duration>
      </Content>
      <ViewButton onClick={() => onViewVideo(video)}>
        Ver Video
      </ViewButton>
    </Card>
  );
});

export default VideoCard;